export default __webpack_public_path__ + "static/media/Carla_Palmer_AHV_In_Moms_We_Trust.2def981c.jpg";